import React from 'react'
import {
	InlinePanel,
	InlinePanelLabel,
	StateParagraph,
	TipsList,
} from '../ItineraryImportPage.styles'
import CenteredState from './CenteredState'
import { SearchGlyph } from './icons'

const NoEventsBody: React.FC = () => (
	<CenteredState
		tone="orange"
		icon={<SearchGlyph size={42} strokeWidth={1.8} />}
		headline="Nothing trip-shaped in there"
	>
		<StateParagraph>
			We read it all the way through and couldn't find any events to add. If your source is a
			confirmation email, double-check it has a date and a place name.
		</StateParagraph>
		<InlinePanel>
			<InlinePanelLabel>Things that work well</InlinePanelLabel>
			<TipsList>
				<li>Forwarded booking confirmations (flights, hotels, restaurants)</li>
				<li>Screenshots of an itinerary your friend texted you</li>
				<li>A PDF guide with day-by-day plans</li>
				<li>Your half-baked notes app draft</li>
			</TipsList>
		</InlinePanel>
	</CenteredState>
)

export default NoEventsBody
